import gql from 'graphql-tag';
import * as types from '../DayPlanTypes';

const query = gql`
  query MealSiblings($date: Date!) {
    me {
      id
      dailyDietPlan(date: $date) {
        ... on ${types.DAY_PLAN} {
          id
          events {
            __typename
            ... on UserDailyDietPlanEventMeal {
              id
              mealType{
                type
                name
              }
              name
              key
              originalMeal{
                id
              }
            }
          }
        }
      }
    }
  }
`;

export default query;
